import Logo from "@/ui/Logo";
import { Button } from "@/components/ui/button";
import { ArrowLeft, FileQuestion } from "lucide-react";
import { useNavigate } from "react-router-dom";

function PageNotFound() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0B0F17] p-4">
      <div className="flex flex-col items-center justify-center text-center max-w-2xl">
        <div className="relative mb-8">
          {/* Animated glow effect */}
          <div className="absolute inset-0 animate-pulse bg-blue-500/10 rounded-full blur-2xl" />
          <div className="relative">
            <div className="text-[150px] font-bold text-transparent bg-clip-text bg-gradient-to-r from-sky-500 to-sky-600 leading-none">
              404
            </div>
          </div>
        </div>

        <h1 className="text-3xl font-bold text-gray-100 mb-4">
          Page Not Found
        </h1>

        <p className="text-gray-400 mb-8 max-w-md">
          The page you're looking for doesn't exist or has been moved. Check the
          URL or try navigating back to the home page.
        </p>

        <div className="flex gap-4">
          <Button
            variant="outline"
            className="bg-transparent border-gray-700 hover:bg-gray-800 text-gray-300"
            onClick={() => navigate(-1)}
          >
            Go Back
          </Button>
          <Button
            variant="default"
            className="bg-primary"
            onClick={() => navigate("/")}
          >
            Return Home
            <Logo className="[&_img]:invert [&_img]:brightness-0" />
          </Button>
        </div>

        {/* Decorative elements */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute -left-4 top-1/4 w-24 h-24 bg-blue-500/10 rounded-full blur-2xl" />
          <div className="absolute right-1/4 bottom-1/4 w-32 h-32 bg-blue-600/10 rounded-full blur-2xl" />
        </div>
      </div>
    </div>
  );
}

export default PageNotFound;
